export default __webpack_public_path__ + "static/media/misc-books3-480w.ad5f713b.png";